import React from 'react';


export let Footer = () => {
    return <div id="footer-wrapper">
        <div id="footer-menu">
            <ul id="secondary-menu-footer" className={"links clearfix secondary-menu"}>
                <li className={"menu-996 first active"}><a href="https://tam-arkiv.se/" title="TAM-ARKIV | Hem" className={"active"}><font>HEM</font></a> </li>
                <li className={"menu-629"}><a href="https://tam-arkiv.se/om-tam-arkiv/" title="OM TAM-ARKIV"><font>Om TAM-Arkiv</font></a></li>
                <li className={"menu-1154"}><a href="https://tam-arkiv.se/kontakt/"><font>KONTAKT</font></a></li>
                <li className={"menu-1645 last"}><a href="https://tam-arkiv.se/about-tam-archives/"><font>In English</font></a> </li>
            </ul>
        </div>
        <div id="footer-text">
            <p>
                <font> | © 2012-2024 TAM Arkiv | </font>
            </p>
        </div>
    </div>
};


// WEBPACK FOOTER //
// ./src/components/common/common.js